import { gql } from '@apollo/client';

export const getBusinessPartnerLinesList = gql`
  query getBusinessPartnerLinesList(
    $pagination: PaginationInput!
    $selectedBusinessPartnerID: String
    $SelectedLineId: String
    $SelectedStatuses: [SalesforceManagement_BusinessPartnerLineStatuses]
    $Attribute: String!
    $Descending: Boolean!
    $keywordSearch: String
  ) {
    SalesforceManagement {
      queries {
        getBusinessPartnerLinesList(
          selectedBusinessPartnerID: $selectedBusinessPartnerID
          SelectedLineId: $SelectedLineId
          SelectedStatuses: $SelectedStatuses
          pagination: $pagination
          OrderBy: { Attribute: $Attribute, Descending: $Descending }
          KeywordSearch: $keywordSearch
        ) {
          paging {
            pageSize
            pageNumber
            totalCount
          }
          items {
            salesforceManagement_BusinessPartnerLine_Id
            salesforceManagement_BusinessPartnerLine_Status
            salesforceManagement_BusinessPartnerLine_BusinessPartnerID {
              id
            }
            salesforceManagement_BusinessPartnerLine_LineID {
              id
              views {
                PlanConfigManagement_all {
                  properties {
                    ExternalCode
                    Name
                    Status
                  }
                }
              }
            }
            salesforceManagement_BusinessPartnerLine_LineCommissionType
            salesforceManagement_BusinessPartnerLine_ValueCurrency {
              Id
              Title
              Symbol
            }
            salesforceManagement_BusinessPartnerLine_LineCommissionRate
            salesforceManagement_BusinessPartnerLine_LineCommissionValue
            salesforceManagement_BusinessPartnerLine_ApplicableOn {
              Id
              Title
            }
            salesforceManagement_BusinessPartnerLine_CreditLimit
            salesforceManagement_BusinessPartnerLine_CreditLimitCurrency {
              Id
              Title
            }
            salesforceManagement_BusinessPartnerLine_GracePeriod
            salesforceManagement_BusinessPartnerLine_Status
            salesforceManagement_BusinessPartnerLine_createdOn
            salesforceManagement_BusinessPartnerLine_modifiedOn
          }
        }
      }
    }

    SalesforceManagement_BusinessPartnerStatuses: __type(
      name: "SalesforceManagement_BusinessPartnerStatuses"
    ) {
      name
      enumValues {
        name
      }
    }
  }
`;

export const activateBusinessPartnerLine = gql`
  mutation activateBusinessPartnerLine($entityId: String!) {
    salesforceManagement {
      entities {
        businessPartnerLine {
          salesforceManagement {
            activateBusinessPartnerLine(entityId: $entityId) {
              id
              views {
                SalesforceManagement_all {
                  properties {
                    Status
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const deactivateBusinessPartnerLine = gql`
  mutation deactivateBusinessPartnerLine($entityId: String!) {
    salesforceManagement {
      entities {
        businessPartnerLine {
          salesforceManagement {
            deactivateBusinessPartnerLine(entityId: $entityId) {
              id
              views {
                SalesforceManagement_all {
                  properties {
                    Status
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
